/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-no-target-blank */
import { CircularProgress, Rating } from "@mui/material";
import { DownloadGuide } from "@unisearch/common";
import {
  getAssets,
  isCourseCompare,
  isCourseFavorite,
  isEmpty,
  isUniCompare,
  isUniFavorite,
  objectToQueryString,
  ucfirst,
} from "@unisearch/helpers";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { Fragment, useState } from "react";
import { BiLinkExternal } from "react-icons/bi";
import { FaBook, FaUniversity } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import { useRecoilValue } from "recoil";
import styles from "./uni_thumb_list_box.module.scss";
const FavoriteAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/favorite"),
  { ssr: false }
);

const CompareAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/compare"),
  { ssr: false }
);

const UniThumbListBox = ({ item, ...props }) => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const [loader, setLoader] = useState([]);
  const sliceItems = item && item.course.length > 0 && item.course.slice(0, 4);
  const MoreExam = ([...exams]) => {
    if (!exams || exams.length <= 1) return false;
    exams.shift();
    if (exams && exams.length > 0) {
      return (
        <div className={styles.examNumber}>
          <strong>+{exams.length} </strong>
          <ul className={`uni-tooltip ${styles.examlist}`}>
            {exams.map((ex, index) => {
              return (
                <li key={`ex_${index}`}>
                  {ex.exam_examName} : {ex.course_score}{" "}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  };

  //return with search query
  const goSearchResult = async (returnPath, university) => {
    setLoader([university]);
    // router.push({
    //   pathname: returnPath,
    //   query: objectToQueryString(router.query),
    // });
    window.open(
      `${returnPath}?${objectToQueryString({ ...router.query, page: 1 })}`,
      "_blank"
    );
    setLoader([]);
    return true;
  };

  return (
    <>
      <div className={styles.grid_box}>
        <div className={styles.head_wrapper}>
          <div className={styles.left}>
            <Link
              legacyBehavior
              href={`/study/${item?.country?.slug}/university/${item?.slug}`}
            >
              <a className={styles.logo_wrapper} target="_blank">
                <img
                  src={
                    item?.logo?.src ||
                    getAssets("assets/images/uni-profile/logo-placeholder.png")
                  }
                  alt={item?.logo?.alt}
                  className={styles.logo}
                />
              </a>
            </Link>

            {/* info */}
            <div className={styles.infos}>
              <Link
                legacyBehavior
                href={`/study/${item?.country?.slug}/university/${item?.slug}`}
              >
                <a className={styles.name} target="_blank">
                  {item?.universityName}
                </a>
              </Link>
              <div className={styles.info}>
                <span className={styles.icon}>
                  <MdLocationOn style={{ fontSize: "14px" }} />
                </span>
                <span className={styles.address}>
                  {item?.city?.name && <>{item?.city?.name},</>}{" "}
                  {item?.state?.name && <>{item?.state?.name},</>}{" "}
                  {item?.country?.name && <> {item?.country?.name}</>}
                </span>
              </div>
              <div className={styles.info}>
                <span className={styles.icon}>
                  <FaUniversity />
                </span>
                <span className={styles.address}>
                  {item.universityType && ucfirst(item.universityType)}{" "}
                  University, Estd {item?.estd}
                </span>
              </div>
              <div className={styles.info}>
                <span className={styles.icon}>
                  <FaBook />
                </span>
                <Link
                  legacyBehavior
                  href={`/study/${item?.country?.slug}/university/${item?.slug}/courses`}
                >
                  <a className={`${styles.address} ${styles.link_course}`}>
                    <span> Courses {item.course.length ?? 0}</span>
                  </a>
                </Link>
              </div>
            </div>
          </div>

          {/* right */}
          <div className={styles.brief_right_wrapper}>
            {parseInt(item?.rating?.totalRating) > 0 && (
              <Fragment>
                <div className={styles.info_rating_number}>
                  {parseInt(item?.rating?.finalRating)}(
                  {parseInt(item?.rating?.totalRating)})
                </div>
                <div className={styles.info_rating_stars}>
                  <Rating
                    name="read-only"
                    value={parseInt(item?.rating?.finalRating)}
                    readOnly
                    sx={{ mb: 1 }}
                  />
                </div>
              </Fragment>
            )}

            <div className={styles.compare_wrapper}>
              <FavoriteAction
                referance="university"
                referanceId={parseInt(item.universityId)}
                is_favorite={isUniFavorite(profileInfo, item.universityId)}
              />

              <CompareAction
                referance="university"
                referanceId={parseInt(item.universityId)}
                is_compared={isUniCompare(profileInfo, item.universityId)}
              />
              {item && !isEmpty(item?.documentInfo) && (
                <DownloadGuide
                  customStyles={{ root: { fontSize: "10px" } }}
                  fileSrc={item?.documentInfo?.documentSrc}
                  documentId={item?.documentInfo?.documentId}
                  documentType="prospectus"
                  universityId={parseInt(item.universityId)}
                />
              )}
            </div>
          </div>
        </div>

        <div className={styles.head_link}>
          {item.website && (
            <div
              className={styles.external_link}
              style={{ paddingTop: "10px" }}
            >
              <a href={item?.website} target="_blank">
                <span>International student website</span>
                <BiLinkExternal />
              </a>
            </div>
          )}
        </div>

        {item?.course?.length > 0 && (
          <>
            <div className={styles.table_wrapper}>
              <table>
                <thead>
                  <tr>
                    <th>Course Name</th>
                    <th>1st Year Total Fees</th>
                    <th className={styles.eligibility}>Eligibility</th>
                    <th>Duration</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {sliceItems &&
                    sliceItems.map((course) => (
                      <tr key={`${Math.random()}_${course.id}`}>
                        <td>
                          <a
                            target="_blank"
                            href={`/study/${item?.country?.slug}/university/${item?.slug}/${course?.slug}`}
                          >
                            {course?.courseName}
                          </a>
                        </td>
                        <td>
                          {item.country && item.country.currencySymbol
                            ? item.country.currencySymbol
                            : ""}
                          {course.tuitionfees && course.tuitionfees.amountFrom
                            ? course.tuitionfees.amountFrom
                            : 0}{" "}
                          <span style={{ fontSize: "9px" }}>
                            (
                            {item.country && item.country.currency
                              ? item.country.currency
                              : ""}
                            )
                          </span>
                        </td>
                        <td>
                          <div className={`${styles.exams} relative`}>
                            {course?.exam[0]?.exam_examName} :{" "}
                            {course?.exam[0]?.course_score}{" "}
                            {MoreExam(course?.exam)}
                          </div>
                        </td>
                        <td>
                          {course.courseDuration ?? ""}{" "}
                          {ucfirst(course.courseDurationType ?? "Months")}
                        </td>
                        <td>
                          <div className={styles.compare_wrapper}>
                            <FavoriteAction
                              referance="course"
                              referanceId={parseInt(course.courseId)}
                              is_favorite={isCourseFavorite(
                                profileInfo,
                                course.courseId
                              )}
                            />
                            <CompareAction
                              referance="course"
                              referanceId={parseInt(course.courseId)}
                              is_compared={isCourseCompare(
                                profileInfo,
                                course.courseId
                              )}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {item.course && item.course.length > 4 && (
              <div className={styles.view_all_link}>
                <button
                  onClick={() => {
                    goSearchResult(
                      `/study/${item?.country?.slug}/university/${item?.slug}/search-courses`,
                      item.universityId
                    );
                  }}
                >
                  {loader && loader.includes(item.universityId) && (
                    <CircularProgress size="10px" color="inherit" />
                  )}{" "}
                  View More {parseInt(item?.course?.length) - 4}{" "}
                  {parseInt(item?.course?.length) > 5
                    ? "Courses ›"
                    : "Course ›"}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UniThumbListBox;
